module.exports = __webpack_public_path__ + "static/img/guanCheNew.dd981e08.png";